import { router } from '@inertiajs/react';
export function visitInertia(url, event, ignoreIfTextSelection) {
    // Ignore right click
    if (event && event.type === 'auxclick' && event.button !== 1) {
        return;
    }
    const selection = window.getSelection()?.toString();
    if (ignoreIfTextSelection &&
        selection &&
        // @ts-ignore
        event?.nativeEvent?.target?.innerText?.includes(selection)) {
        return;
    }
    // Open in new window on middle mouse button or using ctrl/meta key
    if (event &&
        (event.type === 'auxclick' || event.metaKey || event.ctrlKey)) {
        window.open(url);
    }
    else {
        router.visit(url);
    }
}
